
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppButton, AppCard, AppSelect, AppFileUpload, AppDateTimePicker } from '@/components';
import useChallengeAdd from '@/modules/challenge/model/add';
import { ROUTE_NAME_CHALLENGE } from '@/modules/challenge/router';
import { useAppStore } from '@/modules/apps/store';
import { storeToRefs } from 'pinia';

export default defineComponent({
    name: ROUTE_NAME_CHALLENGE.ADD,
    components: { AppFormRow, AppInput, AppButton, AppSelect, AppCard, AppDateTimePicker, AppFileUpload },
    setup() {
        const { appSelectOptions } = storeToRefs(useAppStore());
        const { v$, model, create } = useChallengeAdd();

        return { v$, model, create, appSelectOptions };
    }
});
